import React from 'react';
import { View, Pressable, SxProp, useDripsyTheme } from 'dripsy';

import { TextTitle } from '@/design-system/components/typography';
import { Icon } from '@/design-system/components/icons/Icon';

enum StyleName {
  container = 'container'
}

interface BottomSheetHeaderProps {
  title: string;
  onPress: () => void;
  sx?: SxProp;
}

export const BottomSheetHeader: React.FC<BottomSheetHeaderProps> = ({ title, onPress, sx }) => {
  const { theme } = useDripsyTheme();

  return (
    <View sx={{ ...styles.container, ...sx }}>
      <TextTitle semiBold>{title}</TextTitle>
      <Pressable onPress={onPress}>
        <View>
          <Icon name="cross" color={theme.colors?.$iconDefault as string} />
        </View>
      </Pressable>
    </View>
  );
};

const styles: Record<StyleName, SxProp> = {
  container: {
    pb: '$5',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  }
};
